import { render, staticRenderFns } from "./KPIS.vue?vue&type=template&id=e51c7fb6"
import script from "./KPIS.vue?vue&type=script&lang=js"
export * from "./KPIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports